import muster from '@dbk-legacy/muster';
import { variable, redirectOn } from '@dbk-legacy/muster/helpers';
import { getValues, ref } from '@dbk-legacy/muster/utils';
import { Platform, AsyncStorage } from 'react-native';
// import * as Keychain from 'react-native-keychain';
import lsome from 'lodash/some';
import { isEmpty } from 'lodash';
import DetectBrowser from './detectBrowser';
import { Base64 } from 'js-base64';
import {
  VASCO_STATUSES,
  VASCO_FLOW,
  VASCO_MODAL_TYPES,
  WEBSSO_API_RESPONSE,
  WEBSSO_ERROR_CODES,
  CHANNEL_TYPES,
  DASHBOARD_2FA_REGIONS,
  VASCO_API_ERROR_CODES,
  ERGON_API_ERROR_CODES,
  AUTHORIZATION_ERROR_CODES,
  DOCSIGN_API_ERROR_CODES,
  ENTITLEMENT,
  LANGUAGE_KEY,
  ECREDENTIALS,
  EBANKINGWEBLUX,
  LOGOUT_DSC,
  ERROR_CODE_WSO2,
  FORGOT_PASSWORD_FLOW_STEPS
} from '../../../constants';
import config from '../../../data/settings';
import Settings from '../../../data/settings';
import Guid from '../../../utils/guid';
import { DOCSIGN_PATH, ESIGN_BANNER_ARG } from '../docsign/docsign-muster-constants';
import format from 'date-fns/format';
import getTime from 'date-fns/get_time';
import isValidJsonString from '../../../utils/is-valid-json-string';
import languageData from '../../../data/language-list.json';
import envConfig from '../../../../db-env-build';

export default () => {
  const routeConfig = muster();

  routeConfig


    .match('roster.data.*', redirectOn(ref('app.global.roster.root')))

    // function to get userdetails in userprofile for mandatory business unit and initiator ID
    .path('userprofile.getUserDetails', {
      call: async ({ req }, { get, set }) => {
        const [result] = await getValues(get(`roster.data.getUserProfileDetails`));
        isValidJsonString(result).then(async (data) => {
          if (data) {
            const baseCurrency = data.userPref.sysBaseCcy;
            await Promise.all([
              set('userprofile.userDetails', data.userDtls),
              set('userprofile.prefLanguage', data.userPref.prefLanguage),
              set('userprofile.prefCurrency', data.userPref.prefCurrency),
              set('userprofile.baseCurrency', baseCurrency),

            ]);
            if (data.userPref.prefCurrency)
              await set('auth.destinationCurrency', data.userPref.prefCurrency);
            // EBANK-9918 : Language setting change across initiator ID
            const langCodeStr = data.userPref.prefLanguage.substring(0, 2).toLowerCase();
            await set('auth.langCode', langCodeStr);
          }
        }).catch(() => {
        });
      }
    })


    .path('auth.validateDevice', {
      call: async ({ req }, { get, set, call }) => {
        const { userId, deviceId, deviceToken } = req.args[0];
        set('auth.errorMsg', "");
        set('auth.loginBusy', true);
        await call('auth.resetInfoMessage');
        const ran_str = "random" + Math.round(Math.random() * 100);
        const device = 'APP_V_' + platformPackage.version + '_' + DeviceInfo.getBrand() + '_' + DeviceInfo.getModel() + '_' + DeviceInfo.getSystemName() + '_' + DeviceInfo.getSystemVersion();
        const device_info1 = device.replace(/\./g, '_');
        const device_info = device_info1.replace(/\ /g, '_');

        const [
          authHeader,
          authSuccess,
          message,
          passwordExpired,
          lastSession,
          sessionActive,
          language,
          appVersion
        ] = await getValues(get([
          `roster.ebanking.auth.validateDeviceNewUI.randomStr-${ran_str}.app-${device_info}.${userId}.deviceId-${deviceId}`
          + `.deviceToken-${deviceToken}.authHeader`,
          `roster.ebanking.auth.validateDeviceNewUI.randomStr-${ran_str}.app-${device_info}.${userId}.deviceId-${deviceId}`
          + `.deviceToken-${deviceToken}.authSuccess`,
          `roster.ebanking.auth.validateDeviceNewUI.randomStr-${ran_str}.app-${device_info}.${userId}.deviceId-${deviceId}`
          + `.deviceToken-${deviceToken}.message`,
          `roster.ebanking.auth.validateDeviceNewUI.randomStr-${ran_str}.app-${device_info}.${userId}.deviceId-${deviceId}`
          + `.deviceToken-${deviceToken}.passwordExpired`,
          `roster.ebanking.auth.validateDeviceNewUI.randomStr-${ran_str}.app-${device_info}.${userId}.deviceId-${deviceId}`
          + `.deviceToken-${deviceToken}.lastSession`,
          `roster.ebanking.auth.validateDeviceNewUI.randomStr-${ran_str}.app-${device_info}.${userId}.deviceId-${deviceId}`
          + `.deviceToken-${deviceToken}.sessionActive`,
          `roster.ebanking.auth.validateDeviceNewUI.randomStr-${ran_str}.app-${device_info}.${userId}.deviceId-${deviceId}`
          + `.deviceToken-${deviceToken}.language`,
          `roster.ebanking.app.version.${ran_str}`
        ]));
        console.log("validateDevice status is:", authSuccess);
        const [messages] = await getValues(get('i18n.messages'));
        const [langCode] = await getValues(get('auth.langCode'));
        await call('language.setLanguageValue', { language: langCode, languageData });

        // if (language) {
        //   await call('language.setLanguageValue', { language, languageData });
        // }
        // if (Settings.features.appVersionCheck && platformPackage.version != appVersion) {
        //   await set('auth.invalidVersion', true);
        //   await set('auth.invalidLogin', false);
        //   // await set('auth.errorMsg', 'We have enhanced the app to serve you better. Please download the latest version of Application.');
        //   set('auth.loginBusy', false);
        //   return;
        // }

        if (authSuccess.$type == "error") {
          await set('auth.invalidLogin', true);
          await set('auth.errorMsg', messages['app.login.unableToConnect']);
          set('auth.loginBusy', false);
          set('auth.touchIdVerificationProcess', false);
          return;
        }

        const authSuccessValue = JSON.parse(authSuccess);
        if (authSuccessValue.type === "oldAppError") {
          await set('auth.invalidLogin', true);
          set('auth.loginBusy', false);
          await set('auth.errorMsg', authSuccessValue.encryptionMSG);
          set('auth.touchIdVerificationProcess', false);
          return;
        }

        if (authSuccess) {
          await set('auth.invalidLogin', false);
        } else {
          await set('auth.invalidLogin', true);
          set('auth.loginBusy', false);
          await set('auth.errorMsg', message);
          set('auth.touchIdVerificationProcess', false);
          return;
        }
        const [isVascoActivated] = await getValues(get('vascoauthentication.isVascoActivated'));
        const authenticatedJson = {
          authHeader,
          passwordExpired,
          sessionId: null,
          userId,
          lastSession,
          strLastSession: null,
          userGroup: null,
          authSuccess,
          isVascoActivated,
          channel: CHANNEL_TYPES.APP
        };
        const loginResult = JSON.stringify(authenticatedJson);
        await Promise.all([
          set('auth.authHeader', authHeader),
          set('auth.passwordExpired', passwordExpired),
          set('auth.sessionId', null),
          set('auth.userId', userId),
          set('auth.lastSession', lastSession),
          set('auth.lastSessionTZ', null),
          set('auth.userGroup', null),
          set('auth.authorised', authSuccess),
          set('auth.unAuthorisedUser', false),
          set('auth.channel', CHANNEL_TYPES.APP),
        ]);
        if (sessionActive) {
          const guidStr = Guid();
          get(`roster.data.auth.glblAuthEBankclearOtherSession["${guidStr}"]`);
        }
        await set('auth.authenticationJson', loginResult)
      },
    })

    .path('auth.globalauthloginsolo', {
      call: async ({ req }, { get, set, call }) => {

        await set('auth.invalidVersion', false);
        await set('app.user.cacheId', Date.now());
        await call('auth.resetInfoMessage');
        const { userId, password, data, token, randnr, pubkey, seskey, type = "login" } = req.args[0];

        const ran_str = "random" + Math.round(Math.random() * 100);
        const [messages] = await getValues(get('i18n.messages'));

        const check_dot = userId.includes(".");
        if (check_dot) {
          await set('auth.invalidLogin', true);
          await set('auth.errorMsg', messages['app.auth.invalidLogin']);
          set('auth.loginBusy', false);
          return;
        }

        const [appVersion] = await getValues(get([`roster.ebanking.app.version.${ran_str}`]));
        console.log("appVersion:", appVersion);

        const encryptedPassword = '';

        const device = 'APP_V_' + platformPackage.version + '_' + DeviceInfo.getBrand() + '_' + DeviceInfo.getModel() + '_' + DeviceInfo.getSystemName() + '_' + DeviceInfo.getSystemVersion();
        const deviceInfo1 = device.replace(/\./g, '_');
        const deviceInfo = deviceInfo1.replace(/\ /g, '_');
        const [regionCode] = await getValues(get(['config.regionCode']));

        let oLoginResult = "";
        if (envConfig.envConfig === EBANKINGWEBLUX) {
          const base64UserId = Base64.encode(userId)
          const inputParam = `${base64UserId}#@#${encryptedPassword}#@#${seskey}#@#${token}#@#${data}#@#${deviceInfo}#@#${regionCode}`;
          oLoginResult = JSON.parse(
            await getValues(get(`roster.data.auth.globalAuthLoginVascoNewUIForLUX["${inputParam}"]`))
          );
        } else {
          oLoginResult = JSON.parse(
            await getValues(get(`roster.data.auth.globalAuthLoginVascoNewUI.${userId}.encrypted-${encryptedPassword}.dummySesKey-${seskey}.token-${token}.cryptoPass-${data}.app-${deviceInfo}.${regionCode}`))
          );
        }

        const sessionId = oLoginResult.sessionId;
        const authHeader = oLoginResult.authHeader;
        const authSuccess = oLoginResult.authSuccess;
        const passwordExpired = oLoginResult.passwordExpired;
        const lastSession = oLoginResult.lastSession;
        const strLastSession = oLoginResult.strLastSession;
        const message = (oLoginResult.returnCode && messages['app.errorCode.' + oLoginResult.returnCode]) ? messages['app.errorCode.' + oLoginResult.returnCode] : oLoginResult.message;
        const userGroup = oLoginResult.userGroup;
        const sessionActive = oLoginResult.sessionActive;

        const [langCode] = await getValues(get('auth.langCode'));
        await call('language.setLanguageValue', { language: langCode, languageData });

        if (oLoginResult.returnCode === ERGON_API_ERROR_CODES.user1FAlocked) {
          await set('auth.invalidLogin', true);
          await set('auth.errorMsg', messages['app.error.errorCode.1070']);
          set('auth.loginBusy', false);
          set('auth.touchIdVerificationProcess', false);
          return;
          // await call('vascoauthentication.showVascoModal', VASCO_MODAL_TYPES.failUserLocked);
          // await set('auth.vascoFlow', VASCO_FLOW.secondFactorLocked);
          // return;
        } else if (oLoginResult.returnCode === ERGON_API_ERROR_CODES.invalidCredentials) {
          await set('auth.invalidLogin', true);
          await set('auth.errorMsg', messages['app.auth.invalidLogin']);
          set('auth.loginBusy', false);
          return;
        }
        if (!authSuccess) {
          set('auth.loginBusy', false);
          await set('auth.invalidLogin', true);
          await set('auth.errorMsg', message);
          return;
        }

        await Promise.all([
          set('auth.deviceInfo', deviceInfo),
          set('auth.authHeader', authHeader),
          set('auth.passwordExpired', passwordExpired),
          set('auth.sessionId', sessionId),
          set('auth.userId', userId),
          set('auth.channel', CHANNEL_TYPES.APP),
          set('auth.lastSession', lastSession),
          set('auth.lastSessionTZ', strLastSession),
          set('auth.userGroup', userGroup),
          set('auth.authorised', authSuccess),
        ]);

        if (sessionActive) {
          const guidStr = Guid();
          get(`roster.data.auth.glblAuthEBankclearOtherSession["${guidStr}"]`);
        }

        const [deviceCode] = await getValues(get('device.uniqueId'));
        const [vascoStatus] = await getValues(get([
          `roster.data.vascoauthentication.handleSecondFactorStatus.["${deviceCode}"]`
        ]));
        await set('auth.vascoStatus', vascoStatus);
        if (config.features.vascoAuth) {
          await call('vasco.statusCheck');
        } else {
          await set('auth.vascoFlow', VASCO_FLOW.noVasco);
        }
        const [vascoFlow, isVascoActivated] = await getValues(get(['auth.vascoFlow', 'vascoauthentication.isVascoActivated']));
        const authenticatedJson = {
          authHeader,
          passwordExpired,
          sessionId,
          userId,
          lastSession,
          strLastSession,
          userGroup,
          authSuccess,
          isVascoActivated,
          vascoFlow,
          vascoStatus,
          channel: CHANNEL_TYPES.APP
        };
        const authenticatedJsonString = JSON.stringify(authenticatedJson);
        await set('auth.authenticationJson', authenticatedJsonString);
      },
    })


    .path('auth.authenticatedwrapper', {
      call: async ({ req }, { set, get, call }) => {
        const [credentialsStr] = await getValues(get('auth.authenticationJson'));
        const credentialsJson = JSON.parse(credentialsStr);
        await Promise.all([
          set('auth.authHeader', credentialsJson.authHeader),
          set('auth.channel', credentialsJson.channel),
          set('auth.passwordExpired', credentialsJson.passwordExpired),
          set('auth.sessionId', credentialsJson.sessionId),
          set('auth.userId', credentialsJson.userId),
          set('auth.lastSession', credentialsJson.lastSession),
          set('auth.lastSessionTZ', credentialsJson.strLastSession),
          set('auth.userGroup', credentialsJson.userGroup),
          set('auth.authorised', credentialsJson.authSuccess),
          set('auth.authSuccess', credentialsJson.authSuccess),
          set('auth.vascoFlow', credentialsJson.vascoFlow),
          set('vascoauthentication.isVascoActivated', credentialsJson.isVascoActivated),
          set('auth.vascoStatus', credentialsJson.vascoStatus),
          set('auth.e2eCryptoObj', credentialsJson.e2eCryptoObj),
          // set('ui.busy', true)
        ]);

        if (!credentialsJson.vascoStatus) {
          const [deviceCode] = await getValues(get('device.uniqueId'));
          const [vascoStatus] = await getValues(get([
            `roster.data.vascoauthentication.handleSecondFactorStatus.["${deviceCode}"]`
          ]));
          await set('auth.vascoStatus', vascoStatus);
        }

        if (config.features.vascoAuth) {
          await call('vasco.statusCheck');
        } else {
          await set('auth.vascoFlow', VASCO_FLOW.noVasco);
        }
        const [vascoFlow] = await getValues(get('auth.vascoFlow'));

        await call('portfolio.getInformation');
        const [noEntitlement] = await getValues(get('auth.noEntitlement'));
        const [noEntitlementUserPf] = await getValues(get('auth.noEntitlementUserPf'));
        set('auth.portfolioLoaded', true);

        if (noEntitlementUserPf) {
          return;
        }
        if (noEntitlement) {
          return;
        }
        const [regionCode] = await getValues(get(['config.regionCode']));

        if (regionCode === "CH") {
          // GET USER DETAILS FOR INITIATOR ID AND BUSINESS UNIT
          await call('userprofile.getUserDetails');

          // SET USER PREFERRED LANGUAGE FOR INITIATOR ID AND BUSINESS UNIT
          await call('auth.setUserPrefLanguage');
        }

        await call('loginTerms.getPdfLink');

        if (vascoFlow !== VASCO_FLOW.secondFactorLocked) {
          await call('auth.routesAfterLogin');
        }

        console.log("authenticatedwrapper");
      },
    })
    .path('auth.unAuthorisedUser', variable())
    .path('platform.browser', variable())
    .path('platform.directDownload', variable(false))
    .path('terms.showTermsConditionsCall', {
      call: async ({ req }, { set, get, call }) => {
        const [showTermsConditionsData] = await getValues(get(`roster.data.terms.showTermsConditions`));
        const tcData = await JSON.parse(showTermsConditionsData);
        const [authSuccess] = await getValues(get('auth.authSuccess'));
        const [passwordExpired] = await getValues(get('auth.passwordExpired'));
        const routePath = await getValues(get('auth.path'));
        const showTermsConditions = tcData.showTermsConditions;
        const tcPdfLink = tcData.tcPdfLink;
        const showPrivacyAgreement = tcData.showPrivacyAgreement;
        const paPdfLink = tcData.paPdfLink;
        const rmUserGroup = tcData.isRMUserGroup;
        const tcVersion = tcData.tcVersion;
        const paVersion = tcData.paVersion;
        const newUserTc = tcData.newUserTc;
        const newUserPa = tcData.newUserPa;
        const showSummaryOfServices = tcData.showSummaryOfServices;
        const ssPdfLink = tcData.ssPdfLink;
        const ssVersion = tcData.ssVersion;

        await Promise.all([
          set('terms.showTermsConditions', showTermsConditions),
          set('terms.tcPdfLink', tcPdfLink),
          set('terms.showPrivacyAgreement', showPrivacyAgreement),
          set('terms.paPdfLink', paPdfLink),
          set('terms.tcVersion', tcVersion),
          set('terms.paVersion', paVersion),
          set('terms.newUserTc', newUserTc),
          set('terms.newUserPa', newUserPa),
          set('terms.showSummaryOfServices', showSummaryOfServices),
          set('terms.ssPdfLink', ssPdfLink),
          set('terms.ssVersion', ssVersion),
        ]);


        if ((showTermsConditions || showPrivacyAgreement) && !rmUserGroup) {
          const path = '/terms-conditions';
          await call('auth.dashboard2FARouting', { authSuccess, path });
        } else if (passwordExpired) {
          const path = '/new-user-change-password';
          await call('auth.dashboard2FARouting', { authSuccess, path });
        } else {
          await call('auth.dashboard2FARouting', { authSuccess, path });
        }
      }
    })
    .path('platform.initBrowser', {
      call: async ({ req }, { get, set, call }) => {
        const browser = DetectBrowser(navigator.userAgent);
        // if (browser.name == "chrome" || browser.name == "edge" || browser.name == "ie") {
        //   set('platform.directDownload', true);
        // }
        set('platform.directDownload', true);
        set('platform.browser', browser);
      },
    })

    .path('auth.getGlobalAuthEncryptionKey', {
      call: async ({ req }, { get, set, call }) => {
        const { userId, type } = req.args[0];

        if (type === 'login') {
          set('auth.loginBusy', true);
        }
        const ran_str = "random" + Math.round(Math.random() * 1000);
        const sendToFrontEncryptionKey = {};

        let [oReturn] = ""
        if (envConfig.envConfig === EBANKINGWEBLUX) {
          const base64UserId = Base64.encode(userId);
          const inputParam = `${base64UserId}#@#${ran_str}#@#${type}`;

          [oReturn] = await getValues(get(`roster.data.auth.globalAuthEncryptionJsonForLUX["${inputParam}"]`));
        } else {
          [oReturn] = await getValues(get(`roster.data.auth.globalAuthEncryptionJson.${ran_str}.${userId}.${type}`));
        }
        const [messages] = await getValues(get('i18n.messages'));
        if (oReturn && oReturn.$type == "error") {
          await set('auth.invalidLogin', true);
          if (oReturn.value.message.includes(ERROR_CODE_WSO2)) {
            await set('auth.errorMsg', messages['app.login.errorMessage.WSO2IsDown']);  // Error message when wso2 is down
            await set('auth.isWso2Down', true);
            await set('banner.isDowntime', true); 
          } else {
            await set('auth.errorMsg', messages['app.login.unableToConnect']);
          }
          set('auth.loginBusy', false);
          return;
        }

        const oResult = JSON.parse(oReturn);



        // if(oResult.returnCode != 0 || oResult.randnr.$type == "error")
        if (oResult.returnCode === ERGON_API_ERROR_CODES.invalidCredentials) {
          await set('auth.invalidLogin', true);
          await set('auth.errorMsg', messages['app.auth.invalidLogin']);
          set('auth.loginBusy', false);

        } else if (oResult.returnCode != 0) {
          await set('auth.invalidLogin', true);
          const errorMessage = oResult.encryptionMSG.$type == "error" || oResult.encryptionMSG == '' ? messages[app.login.error.connectionError] : (oResult.returnCode && messages['app.error.errorCode.' + oResult.returnCode]) ? messages['app.error.errorCode.' + oResult.returnCode] : oResult.encryptionMSG;
          await set('auth.errorMsg', errorMessage);
          set('auth.loginBusy', false);



        } else {

          sendToFrontEncryptionKey.userId = userId;
          sendToFrontEncryptionKey.modulus = oResult.modulus;
          sendToFrontEncryptionKey.exponent = oResult.exponent;
          sendToFrontEncryptionKey.token = oResult.token;
          sendToFrontEncryptionKey.seskey = oResult.seskey;
          sendToFrontEncryptionKey.pwdModeCur = oResult.pwdModeCur;
          sendToFrontEncryptionKey.pwdModeNew = oResult.pwdModeNew;
          sendToFrontEncryptionKey.randnr = oResult.randnr;
          sendToFrontEncryptionKey.pubkey = oResult.pubkey;
          sendToFrontEncryptionKey.keyType = oResult.keyType;

          await set('auth.cryptoEncryptedObj', sendToFrontEncryptionKey);

          if (type === 'login') {
            await set('auth.cryptoEncryptedObjSuccess', true);
          }
        }

      }
    })
    .path('globalauth.authorizeWebSSOUser', {
      call: async ({ req }, { get, set, call }) => {
        await set('webssoauthentication.isSynced', false);
        const email = req.args[0].webssoLoggedInEmail;
        const [messages] = await getValues(get('i18n.messages'));

        const [response] = await getValues(get([`roster.ebanking.auth.glblAuthEBankauthorizeWebSSOUser["${email}"]`])); // changed to non-roster path to avoid multi call if no valid authentication

        if (response.$type == WEBSSO_API_RESPONSE.error) {
          await Promise.all([
            set('webssoauthentication.webssoEnabled', false),
            set('webssoauthentication.dwoEntitlementFlag', false),
            set('webssoauthentication.errorMessage', messages['app.login.unableToConnect']),
            set('webssoauthentication.isSynced', true)
          ]);
          return;
        }

        const data = JSON.parse(response);
        if (data.returnCode == WEBSSO_ERROR_CODES.SUCCESS && data.dwoEntitlementFlag) {
          await Promise.all([
            set('auth.authHeader', data.jwtToken2FA),
            set('auth.passwordExpired', ""),
            set('auth.sessionId', ""),
            set('auth.userId', data.userId),
            set('auth.lastSession', data.lastSession),
            set('webssoauthentication.webssoEnabled', true),
            set('auth.authSuccess', true),
            set('webssoauthentication.isSynced', true)
          ]);

          if (data && data.lng) {
            const language = data.lng;
            await call('language.setLanguageValue', { language, languageData });
          }
          await call('auth.getDashboardInfo');
        } else {
          let errMessage = "";
          if (data.returnCode == WEBSSO_ERROR_CODES.unexpectedError) {
            errMessage = messages['app.websso.error.unexpected'];
          } else if (data.returnCode == WEBSSO_ERROR_CODES.notAuthorized || data.returnCode == WEBSSO_ERROR_CODES.noRecordToFetch) {
            errMessage = messages['app.websso.error.user.not.authorized'];
          } else if (data.returnCode == WEBSSO_ERROR_CODES.serviceUnAvailable) {
            errMessage = messages['app.websso.error.service.unavailable'];
          } else if (data.returnCode == WEBSSO_ERROR_CODES.accountBlocked) {
            errMessage = messages['app.websso.error.user.account.blocked'];
          } else if (data.returnCode == WEBSSO_ERROR_CODES.multipleUserID) {
            errMessage = messages['app.websso.error.user.multiple.id'];
          } else {
            errMessage = messages['app.websso.error.unexpected'];
          }
          await Promise.all([
            set('webssoauthentication.webssoEnabled', false),
            set('webssoauthentication.dwoEntitlementFlag', false),
            set('webssoauthentication.errorMessage', errMessage),
            set('webssoauthentication.isSynced', true)
          ]);
        }
      }
    })

    .path('auth.globalauthlogin', {
      call: async ({ req }, { get, set, call }) => {
        // set('auth.loginBusy', true);
        await set('app.user.cacheId', Date.now());
        await call('auth.resetInfoMessage');

        // const { userId, password, type = "login"} = req.args[0];
        const { userId, password, data, token, randnr, pubkey, seskey, type = "login" } = req.args[0];



        const ran_str = "random" + Math.round(Math.random() * 100);
        const [messages] = await getValues(get('i18n.messages'));

        const check_dot = userId.includes(".");
        if (check_dot) {
          await set('auth.invalidLogin', true);
          await set('auth.errorMsg', messages['app.auth.invalidLogin']);
          set('auth.loginBusy', false);
          return;
        }

        const encryptedPassword = '';

        let agent = '';
        if (typeof navigator !== 'undefined' && navigator) {
          agent = navigator.userAgent;
        }
        const browserName = DetectBrowser(agent);
        const device = browserName != '' && browserName != null ? 'WEB_' + browserName.name + '_' + browserName.version : '';
        const deviceInfo = device.replace(/\./g, '_');
        const [regionCode] = await getValues(get(['config.regionCode']));

        let oLoginResult = ""
        if (envConfig.envConfig === EBANKINGWEBLUX) {
          const base64UserId = Base64.encode(userId);
          const inputParam = `${base64UserId}#@#${encryptedPassword}#@#${seskey}#@#${token}#@#${data}#@#${deviceInfo}#@#${regionCode}`;
          oLoginResult = JSON.parse(
            await getValues(get(`roster.data.auth.globalAuthLoginVascoNewUIForLUX["${inputParam}"]`))
          );
        } else {
          oLoginResult = JSON.parse(
            await getValues(get(`roster.data.auth.globalAuthLoginVascoNewUI.${userId}.encrypted-${encryptedPassword}.dummySesKey-${seskey}.token-${token}.cryptoPass-${data}.app-${deviceInfo}.${regionCode}`))
          );
        }

        await Promise.all([
          await set('auth.userId', userId),
          await set('auth.deviceInfo', deviceInfo),
          await set('auth.authHeader', oLoginResult.authHeader),
          await set('auth.sessionId', oLoginResult.sessionId),
          await set('auth.channel', CHANNEL_TYPES.WEB),
          await set('auth.deviceCode', CHANNEL_TYPES.BROWSER),
          await set('auth.eCredPwd', oLoginResult.eCredPwd)
        ]);

        //convert lock out time to seconds/minutes/hours
        function getLockOutTime(millis) {
          const errMsg = messages['app.error.errorCode.1072']
          var n = parseInt(millis) / 1000;
          if (n < 10) {
            n = Math.round(n);
            return messages['app.auth.invalidLogin'];
          } else if (n < 60) {
            n = Math.round(n);
            return errMsg + n + " seconds";
          } else if (n <= 3600) {
            n = Math.round(n / 60);
            return errMsg + n + " minutes";
          } else {
            n = Math.round(n / 3600);
            return errMsg + n + " hours";
          }
        }

        const authSuccess = oLoginResult.authSuccess;
        const passwordExpired = oLoginResult.passwordExpired;
        const lastSession = oLoginResult.lastSession;
        const strLastSession = oLoginResult.strLastSession;
        const message = oLoginResult.message;
        const userGroup = oLoginResult.userGroup;
        const eCredPwd = oLoginResult.eCredPwd;
        const tempLockTimeOut = oLoginResult.tempLockTimeOut;
        // TESTING THE user group Client Admin
        // const userGroup = 10;
        console.log("authSuccess is:", authSuccess);
        const e2eCryptoObj = oLoginResult.e2eCryptoObj;

        if (oLoginResult.returnCode === ERGON_API_ERROR_CODES.user1FAlocked) {
          await set('auth.invalidLogin', true);
          await set('auth.errorMsg', messages['app.error.errorCode.1070']);
          set('auth.loginBusy', false);
          return;
        }
        if (oLoginResult.returnCode === ERGON_API_ERROR_CODES.invalidCredentials) {
          await set('auth.invalidLogin', true);
          await set('auth.errorMsg', messages['app.auth.invalidLogin']);
          set('auth.loginBusy', false);
          return;
        }
        // WMCE-459: Reset Password for E-Credentials expired, error message displayed on login
        if (oLoginResult.returnCode === ERGON_API_ERROR_CODES.passwordExpired) {
          await set('auth.invalidLogin', true);
          await set('auth.errorMsg', messages['app.forgotPassword.tempPasswordExpiry']);
          set('auth.loginBusy', false);
          return;
        }

        //WMCE-11138 APT Fix
        if (oLoginResult.returnCode === ERGON_API_ERROR_CODES.accTempLock) {
          if (tempLockTimeOut) {
            const timeString = await getLockOutTime(tempLockTimeOut);
            await set('auth.invalidLogin', true);
            await set('auth.errorMsg', timeString);
            set('auth.loginBusy', false);
          } else {
            await set('auth.invalidLogin', true);
            await set('auth.errorMsg', messages['app.auth.invalidLogin']);
            set('auth.loginBusy', false);
          }
          return;
        }

        // if (eCredPwd && eCredPwd.status === ECREDENTIALS.EPWD_RESET_INITIATED
        //   && eCredPwd.pwdValid && (eCredPwd.maxCount - eCredPwd.attemptCount) >= 0) {
        //     set('auth.loginBusy', false);
        //     await call('ui.history.replace', { pathname: '/profile/change-password' });
        //      return;
        // }

        if (oLoginResult.sessionActive === true) {
          const guidStr = Guid();
          get(`roster.data.auth.glblAuthEBankclearOtherSession["${guidStr}"]`);
        }

        if (authSuccess) {
          const [langCode] = await getValues(get('auth.langCode'));
          let languageObj = languageData.languageList[0];
          languageData.languageList.every((element, index) => {
            if (element.langCode.toLowerCase().indexOf(langCode.toLowerCase()) !== -1) {
              languageObj = element;
              return false;
            } return true;
          });
          await set('auth.passwordExpired', passwordExpired);
          await set('auth.authSuccess', authSuccess);
          const [isLanguageChangeFromLogin] = await getValues(get('languages.isLanguageChange'));
          if (isLanguageChangeFromLogin) {
            await call('userprofile.saveUserPrefLanguage', { prefLanguage: languageObj });
          }
        } else {
          set('auth.loginBusy', false);
          await set('auth.invalidLogin', true);
          await set('auth.errorMsg', message);
          return;
        }


        await Promise.all([
          set('auth.passwordExpired', passwordExpired),
          set('auth.lastSession', lastSession),
          set('auth.lastSessionTZ', strLastSession),
          set('auth.userGroup', userGroup),
          set('auth.eCredPwd', eCredPwd),
          set('auth.e2eCryptoObj', e2eCryptoObj)
        ]);

        await call('auth.userGroupCheck');
        const [noRmAccess] = await getValues(get('auth.noRmAccess'));
        if (noRmAccess) {

          await set('auth.loginBusy', false);
        } else {
          await set('auth.channel', CHANNEL_TYPES.WEB)
          await set('auth.deviceCode', CHANNEL_TYPES.BROWSER);
          await call('auth.getDashboardInfo');
        }
      }
    })
    .path('vasco.checkVascoFlow', {
      call: async ({ req }, { get, set, call }) => {
        let vascoActivated = false;
        const [webssoEnabled] = await getValues(get('webssoauthentication.webssoEnabled'));
        const [passwordExpired] = await getValues(get('auth.passwordExpired'));
        if (config.features.vascoAuth && !webssoEnabled) {
          const deviceCode = "BROWSER";
          let [secondFactorStatusResponse] = await getValues(get([`roster.data.vascoauthentication.handleSecondFactorStatus.["${deviceCode}"]`]));

          secondFactorStatusResponse = JSON.parse(secondFactorStatusResponse);
          await set('vascoauthentication.isNTB', secondFactorStatusResponse.ntb);
          await set('vascoauthentication.gracePeriod', secondFactorStatusResponse.gracePeriod);


          // CODE FOR MOCK TESTING ============================= START ====================
          // To mock Vasco Vasco 2FA
          // secondFactorStatusResponse.statusDtls[0].vascoStatus = VASCO_STATUSES.complete;
          // To mock UserLock on login
          // secondFactorStatusResponse.statusDtls[0].vascoStatus = VASCO_STATUSES.pinError;
          // To mock RSA
          // secondFactorStatusResponse.statusDtls[0].vascoStatus = VASCO_STATUSES.pending;
          // To MOCK ETB flow
          // await set('vascoauthentication.isNTB', false);
          // await set('vascoauthentication.gracePeriod', 20);
          // for NTB flow
          // await set('vascoauthentication.isNTB', true);
          // CODE FOR MOCK TESTING ============================= END ====================
          // this is for static configuration..
          if (config.defaultEnvironment == 'static') {
            secondFactorStatusResponse.statusDtls[0].vascoStatus = VASCO_STATUSES.complete;
          }

          if (secondFactorStatusResponse) {
            // If at least one device has ACT_COMPLETE status, then can proceed with Vasco 2fa
            const isVascoComplete = lsome(secondFactorStatusResponse.statusDtls, (statusDtl) => statusDtl.vascoStatus === VASCO_STATUSES.complete);
            // If at least one device has ACT_PIN_ERROR status, then show Lock User modal
            const isUserLocked = lsome(secondFactorStatusResponse.statusDtls, (statusDtl) => statusDtl.vascoStatus === VASCO_STATUSES.pinError);

            if (isUserLocked || secondFactorStatusResponse.returnCode === VASCO_API_ERROR_CODES.user2FALocked || secondFactorStatusResponse.returnCode === VASCO_API_ERROR_CODES.user2FADisabled) {
              await set('vascoauthentication.vascoModalType', VASCO_MODAL_TYPES.failUserLocked);
              await set('vascoauthentication.vascoVisible', true);

            } else if (isVascoComplete) {
              await set('auth.vascoFlow', VASCO_FLOW.browser);
              vascoActivated = true;
              await set('auth.vascoActivated', vascoActivated);
            } else if (!passwordExpired) {
              await set('auth.vascoFlow', VASCO_FLOW.notActivated);
              await set('vascoauthentication.vascoModalType', VASCO_MODAL_TYPES.notActivated);
              await set('vascoauthentication.hideVascoActivatedFlag', true);
              // await set('vascoauthentication.vascoVisible', true);
            }
          } else {
            // ERROR in secondFactorStatusResponse response
            await set('auth.vascoFlow', VASCO_FLOW.noVasco);
          }
        } else {
          await set('auth.vascoFlow', VASCO_FLOW.noVasco);
        }
      }
    })

    .path('vasco.fetchSecondFactorStatusDetails', {
      call: async ({ req }, { get, set, call }) => {
        await set('vascoauthentication.showSpinner', true);

        const deviceCode = "BROWSER";
        const inputs = `${deviceCode}#@#`;
        const guidStr = Guid();
        let [secondFactorStatusResponse] = await getValues(get([`roster.data.vascoauthentication.fetchSecondFactorStatusDetails.["${inputs}"]["${guidStr}"]`]));

        secondFactorStatusResponse = JSON.parse(secondFactorStatusResponse);
        await set('vascoauthentication.showSpinner', false);
        await set('vascoauthentication.userDeviceDetails', secondFactorStatusResponse.statusDtls || []);

      }
    })

    .path('auth.getDashboardInfo', {
      call: async ({ req }, { get, set, call }) => {


        const ran_str = "random" + Math.round(Math.random() * 1000);
        const [messages] = await getValues(get('i18n.messages'));
        const [passwordExpired] = await getValues(get('auth.passwordExpired'));
        const [webssoEnabled] = await getValues(get('webssoauthentication.webssoEnabled')); // EBANK-19400

        const [regionCode] = await getValues(get(['config.regionCode']));
        if (regionCode === 'CH') {
          // GET USER DETAILS FOR INITIATOR ID AND BUSINESS UNIT
          await call('userprofile.getUserDetails');
          // SET USER PREFERRED LANGUAGE FOR INITIATOR ID AND BUSINESS UNIT
          await call('auth.setUserPrefLanguage');
        }

        // if (DASHBOARD_2FA_REGIONS.includes(regionCode)) {
        // await call('portfolio.getAllInfo');
        // } else  //EBANK-19400

        // region specific changes

        await call('auth.checkEntitlementUserPf');

        const [noEntitlementUserPf] = await getValues(get('auth.noEntitlementUserPf'));
        const [clientAdminAccess] = await getValues(get('auth.clientAdminAccess'));

        if (noEntitlementUserPf) {
          await set('auth.invalidLogin', true);
          await set('auth.errorMsg', messages['app.auth.invalidAccessUser']);
          set('auth.loginBusy', false);
          return;
        }
        {

          const path = "";
          if (regionCode !== 'CH') {// JIRA WMCE-406 - user-entitlement is shifted on dashboard for ch
            {
              await call('vasco.checkVascoFlow');
              const _entitlementListData = await getValues(get(`roster.data.getEntitlementList`));
              const parsedEntitlementData = JSON.parse(_entitlementListData);
              const oEntitlementList = parsedEntitlementData;
              const entitlementModules = parsedEntitlementData && parsedEntitlementData.modules;
              const adminRead = oEntitlementList.marqueeadmin || (oEntitlementList.esign_rmops && clientAdminAccess) || false;
              await set('auth.entitlement', oEntitlementList);
              await set('auth.isAdminUser', adminRead);


              //   /* Commented for EBANK-19400

              //   const _portfolioDetails = await getValues(get(`roster.data.portfolios.getDashboardData`));
              //   const dashboardData = JSON.parse(_portfolioDetails);
              //   // const oEntitlementList = dashboardData.entitlementList;
              //   const _insightRead = dashboardData.insightRead;
              //   // This is for eDelivery

              //   const edeliveryPreference = dashboardData.userPrefEdelivery;
              //   const edelPref = JSON.parse(edeliveryPreference).edelPref;
              //   await set('edelivery.showPrompt', edelPref);
              //   if (edelPref === 0) {
              //     await set('edelivery.subscription', false);
              //   }
              //   // eDelivery end

              //   // /EBANK-19400 to check
              //   await set('auth.topPortfolio', dashboardData.portfolioTop);
              //   await set('auth.portfolioLength', dashboardData.portfolioLength);
              //   await set('auth.insightsRoles', dashboardData.insightsRoles);
              //   await set('auth.vascoServerTime', dashboardData.serverAuthTime.vascoAuthenticationServerTime);
              //   // / EBANK-19400 to check end

              //   // Testing

              //   // 2 Check entitlment role instead of user group

              //   oEntitlementList.insights = _insightRead; */

              await set('auth.entitlement', oEntitlementList);

              await set('auth.isAdminUser', adminRead); // EBANK-19400

              const portfolioRead = oEntitlementList.dashboard || oEntitlementList.portfolio || false;
              const maturitiesRead = oEntitlementList.maturities || false;
              const insightsRead = oEntitlementList.insights || false;
              const reportsRead = oEntitlementList.reports || false;
              const notificationRead = oEntitlementList.notification || false;

              if (entitlementModules.includes(ENTITLEMENT.tradingModule)) {
                await set('auth.entitlements.trading', true);
                // Feature/EBANK-17839 create app without rendering
                // const [showTrade] = await getValues(get('app.config.trading.tradeComponentDisabled'));
                // if(!showTrade)
                //   await set('auth.entitlements.trading', true);
              }

              if (!adminRead && !portfolioRead && !maturitiesRead && !insightsRead && !reportsRead) {
                await set('auth.noEntitlement', true);
                set('auth.loginBusy', false);
                return;
              }
              let path = "";
              if (!adminRead) {
                path = (portfolioRead && '/portfolios') || (maturitiesRead && '/maturities') || (insightsRead && '/insights') || (reportsRead && '/reports');

                if (webssoEnabled) {
                  await set('rsa.rsaAuthorised', true);
                } else {
                  await set('rsa.rsaAuthorised', false);
                }
                console.log('notificationRead', notificationRead);
                if (notificationRead) {
                  call('notifications.getUserNotifications');
                }
              }
              else {
                path = '/admin';
                await set('auth.authorised', true);
                await set('rsa.rsaAuthorised', false);
              }

            }

            await set('auth.entitlementPath', path);
          }


          // EBANK-19400 start
          let vascoActivated = false;
          if (config.features.vascoAuth && !webssoEnabled) {
            const deviceCode = "BROWSER";
            let [secondFactorStatusResponse] = await getValues(get([`roster.data.vascoauthentication.handleSecondFactorStatus.["${deviceCode}"]`]));

            secondFactorStatusResponse = JSON.parse(secondFactorStatusResponse);
            await set('vascoauthentication.isNTB', secondFactorStatusResponse.ntb);
            await set('vascoauthentication.gracePeriod', secondFactorStatusResponse.gracePeriod);


            // CODE FOR MOCK TESTING ============================= START ====================
            // To mock Vasco Vasco 2FA
            //  secondFactorStatusResponse.statusDtls[0].vascoStatus = VASCO_STATUSES.complete;
            // To mock UserLock on login
            //  secondFactorStatusResponse.statusDtls[0].vascoStatus = VASCO_STATUSES.pinError;
            // To mock RSA
            // secondFactorStatusResponse.statusDtls[0].vascoStatus = VASCO_STATUSES.pending;
            // To MOCK ETB flow
            // await set('vascoauthentication.isNTB', false);
            //  await set('vascoauthentication.gracePeriod', 20);
            // for NTB flow
            //  await set('vascoauthentication.isNTB', true);
            // CODE FOR MOCK TESTING ============================= END ====================
            // this is for static configuration..
            if (config.defaultEnvironment == 'static') {
              secondFactorStatusResponse.statusDtls[0].vascoStatus = VASCO_STATUSES.complete;
            }

            if (secondFactorStatusResponse) {
              // If at least one device has ACT_COMPLETE status, then can proceed with Vasco 2fa
              const isVascoComplete = lsome(secondFactorStatusResponse.statusDtls, (statusDtl) => statusDtl.vascoStatus === VASCO_STATUSES.complete);
              // If at least one device has ACT_PIN_ERROR status, then show Lock User modal
              const isUserLocked = lsome(secondFactorStatusResponse.statusDtls, (statusDtl) => statusDtl.vascoStatus === VASCO_STATUSES.pinError);
              await set('vascoauthentication.twoFaRegisPendingCode', secondFactorStatusResponse.returnCode);
              if (isUserLocked || secondFactorStatusResponse.returnCode === VASCO_API_ERROR_CODES.user2FALocked || secondFactorStatusResponse.returnCode === VASCO_API_ERROR_CODES.user2FADisabled) {
                await set('auth.errorMsg', messages['app.error.errorCode.1070']);
                await set('auth.invalidLogin', true);
                set('auth.loginBusy', false);
                await set('vascoauthentication.vascoModalType', VASCO_MODAL_TYPES.failUserLocked);
                await set('vascoauthentication.vascoVisible', true);
                return;
              } else if (isVascoComplete) {
                await set('auth.vascoFlow', VASCO_FLOW.browser);
                vascoActivated = true;
                await set('auth.vascoActivated', vascoActivated);
              } else if (!passwordExpired) {
                await set('auth.vascoFlow', VASCO_FLOW.notActivated);
                await set('vascoauthentication.vascoModalType', VASCO_MODAL_TYPES.notActivated);
                await set('vascoauthentication.hideVascoActivatedFlag', true);
                await set('vascoauthentication.vascoVisible', true);
              }
            } else {
              // ERROR in secondFactorStatusResponse response
              await set('auth.vascoFlow', VASCO_FLOW.noVasco);
            }
          } else {

            await set('auth.vascoFlow', VASCO_FLOW.noVasco);
          }
          // EBANK-19400 end
          await call('auth.routesAfterLoginCH', path);
        }
      }
    })

    .path('auth.getDashboardContent', {
      call: async ({ req }, { set, get, call }) => {
        const [regionCode] = await getValues(get(['config.regionCode']));
        const [messages] = await getValues(get('i18n.messages'));
        // JIRA WMCE-406
        if (regionCode === 'CH') {
          /* Moved these calls in extender.js WMCE-4427 Batched calls for dashboard
            await call('auth.entitlementCheck');
            const [noEntitlementLt] = await getValues(get('auth.noEntitlement'));
            if (noEntitlementLt) {
              await set('auth.authorised', false);
              set('auth.loginBusy', false);
              await call('ui.history.replace', { pathname: '/login' });
              return;
            }
          */
          await call('auth.getDashboardSummaryData');
        }
        else {
          const [entitlement] = await getValues(get('auth.entitlement'));
          // JIRA WMCE-406
          if (entitlement.insights) {
            const [_insightsRoles] = await getValues(get('roster.data.getInsightRoles',));
            await set('cioinsights.roles', _insightsRoles);
          }
          // DASHBOARD CONTENT RELATED CHECKS START
          const [portfolioId] = await getValues(get('app.user.selectedPortfolioId'))
          if (!portfolioId) {

            const ran_str = "random" + Math.round(Math.random() * 1000);



            const [_portfoliosTop, _portfolioLength, _cache,] = await getValues(get([
              `roster.data.portfolios.top`,
              `roster.data.portfolios.length`,
              //  'roster.data.getInsightRoles',
              `roster.data.cache.${ran_str}`,  // req[0] is ran_str
            ]));

            const topPortfolio = await JSON.parse(_portfoliosTop);

            // await set('cioinsights.roles', _insightsRoles);
            // ALVIN: this is temporary fix, we need to make get currency work inside getValues
            await set('app.user.portfolios.length', _portfolioLength);

            if (isEmpty(topPortfolio)) {
              await set('auth.invalidLogin', true);
              await set('auth.errorMsg', messages['app.auth.portfolio.noAccess']);
              set('auth.loginBusy', false);
              return;
            }
            const portfolioId = topPortfolio.id;
            const title = topPortfolio.title;
            const referenceCurrency = topPortfolio.referenceCurrency;
            const relId = topPortfolio.relId;
            const branchCode = topPortfolio.branchCode;
            const isPaymentAvailable = topPortfolio.isPaymentAvailable;
            if (portfolioId.$type == 'notFound') {
              await call('ui.history.replace', { pathname: '/noportfolios' });
              return;
            }

            const portfolio = { id: portfolioId, title, referenceCurrency, relId, branchCode, isPaymentAvailable };

            await set('app.user.selectedPortfolioId', portfolioId);
            await set('app.user.selectedPortfolioData', portfolio);
            await set('auth.authorised', true);
            set('ui.state.portfolio.view.selectedId', 'chart');
            set('portfolio.portfolioBarDismissed', false);


            // const [_discoveryHistoryList] = await getValues(get('auth._discoveryHistoryList')); Suraj
            const [_discoveryHistoryList] = await getValues(get([
              'roster.data.discovery.history'
            ]));
            if (_discoveryHistoryList.$type != 'error' || _discoveryHistoryList.$type != 'atom') {
              await set('discovery.history', _discoveryHistoryList);
            } else {
              await set('discovery.history', []);
            }

            // Transition to Portfolio screen is done once we get portfolio data
            const [loadportfoliosrc] = await getValues(get('auth.loadportfoliosrc'));
            if (loadportfoliosrc) {
              call('ui.history.push', { pathname: '' });
              await set('auth.loadportfoliosrc', false);
            }

            const [docsignFeature] = await getValues(get(['config.docsign']));
            if (docsignFeature) {

              const [showDocsignBannerResponse] = await getValues(get('auth.docsignData'));
              if (showDocsignBannerResponse) {
                if (showDocsignBannerResponse.returnCode === DOCSIGN_API_ERROR_CODES.SUCCESS_INT || showDocsignBannerResponse.returnCode === DOCSIGN_API_ERROR_CODES.SUCCESS) {
                  await set('docsign.showDocsignBanner', showDocsignBannerResponse.data.showBanner === 'Y');
                  await set('docsign.firstTimeSubscription', showDocsignBannerResponse.data.showBanner === 'Y');
                } else if (showDocsignBannerResponse.returnCode === DOCSIGN_API_ERROR_CODES.NO_DOCSIGN_DATA_INT || showDocsignBannerResponse.returnCode === DOCSIGN_API_ERROR_CODES.NO_DOCSIGN_DATA) {
                  await set('docsign.errorMsg', messages['app.digisign.error.tryagain']);
                } else {
                  await set('docsign.errorMsg', messages['app.digisign.error.tryagain']);
                }
              } else {
                await set('docsign.errorMsg', messages['app.digisign.error.tryagain']);
              }
            }
            await call('auth.checkIsPaymentAvailable');
            /* WMCE-4427 Shifted call in extender.js for CH
           //  JIRA WMCE-406 notification api-call after 2FA for ch
            if (regionCode === 'CH') {
              if (entitlement.notification) {
                call('notifications.getUserNotifications');
              }
            }
            */
          }
        }
        // DASHBOARD CONTENT RELATED CHECKS END
      }
    })

    .path('auth.routesAfterLogin', {
      call: async ({ req }, { set, get, call }) => {
        const path = req.args[0];
        const [docsignFeature] = await getValues(get(['config.docsign']));
        let [_insightsRoles] = await getValues(get('auth.insightsRoles'));
        if (!_insightsRoles) {
          _insightsRoles = "notifications";
        }

        const banner = ESIGN_BANNER_ARG;
        const inputs = `${banner}`;
        const guidStr = Guid();
        const [lastLoginValue] = await getValues(get(['auth.lastSession']));
        const formattedValue = format(getTime(lastLoginValue), 'YYYY-MM-DDTHH:mm:ssZ');
        const [entitlement] = await getValues(get('auth.entitlement'));
        const notificationRead = entitlement.notification || false;
        const [langCode] = await getValues(get('auth.langCode'));

        let languageObj = languageData.languageList[0];
        languageData.languageList.every((element, index) => {
          if (element.langCode.toLowerCase().indexOf(langCode.toLowerCase()) !== -1) {
            languageObj = element;
            return false;
          } return true;
        });
        await getValues(get(`roster.data.userprofile.setUserPreferredLanguage["${languageObj.langCode}"]["${guidStr}"]`));

        const [authSuccess] = await getValues(get('auth.authSuccess'));
        const [passwordExpired] = await getValues(get('auth.passwordExpired'));
        const routePath = await getValues(get('auth.path'));
        const [vascoActivated] = await getValues(get('auth.vascoActivated'));
        const [webssoEnabled] = await getValues(get('webssoauthentication.webssoEnabled'));
        const [adminRead] = await getValues(get('auth.isAdminUser'));
        if (!adminRead) {
          const [_ccyDiscoveryTermsRmiaData,
            docsignData,
            notificationsData] = await getValues(get([
              `roster.data.portfolios.ccyDiscoveryTermsRmia["${langCode}"]`,
              docsignFeature ? `${DOCSIGN_PATH}.showUserBanner["${inputs}"]["${guidStr}"]` : `portfolios.blank`,
              notificationRead ? `roster.data.notifications.getUserNotifications["${_insightsRoles}"]["${formattedValue}"]` : `portfolios.blank`
            ]));
          const oCcyDiscoveryTermsRmiaData = JSON.parse(_ccyDiscoveryTermsRmiaData);

          await set('auth._discoveryHistoryList', oCcyDiscoveryTermsRmiaData.discoveryStatus);
          await set('auth.rmiaDetails', oCcyDiscoveryTermsRmiaData.rmiaDetails);
          await set('auth.notificationData', JSON.parse(notificationsData));
          await set('auth.docsignData', JSON.parse(docsignData));

          if (oCcyDiscoveryTermsRmiaData.currency.currency) {
            await set('auth.destinationCurrency', oCcyDiscoveryTermsRmiaData.currency.currency)
          }
          const showTermsConditionsData = oCcyDiscoveryTermsRmiaData.termsConditions;
          let tcData = '';
          if (showTermsConditionsData.$type == "error") {
            tcData = {
              'showTermsConditions': false,
              'tcPdfLink': '',
              'showPrivacyAgreement': '',
              'paPdfLink': '',
              'isRMUserGroup': '',
              'tcVersion': '',
              'paVersion': '',
              'newUserTc': '',
              'newUserPa': ''
            };
          } else {
            tcData = await showTermsConditionsData;
          }

          const showTermsConditions = tcData.showTermsConditions;
          const showTermsConditionsChat = tcData.showTermsConditionsChat;
          const tcPdfLink = tcData.tcPdfLink;
          const showPrivacyAgreement = tcData.showPrivacyAgreement;
          const paPdfLink = tcData.paPdfLink;
          const rmUserGroup = tcData.isRMUserGroup;
          const tcVersion = tcData.tcVersion;
          const paVersion = tcData.paVersion;
          const tcChatVersion = tcData.tcChatVersion;
          const newUserTc = tcData.newUserTc;
          const newUserPa = tcData.newUserPa;
          const tcChatPdfLink = tcData.tcChatPdfLink;



          await Promise.all([
            set('terms.showTermsConditions', showTermsConditions),
            set('terms.tcPdfLink', tcPdfLink),
            set('terms.showPrivacyAgreement', showPrivacyAgreement),
            set('terms.paPdfLink', paPdfLink),
            set('terms.tcVersion', tcVersion),
            set('terms.paVersion', paVersion),
            set('terms.newUserTc', newUserTc),
            set('terms.newUserPa', newUserPa),
            set('terms.rmUserGroup', rmUserGroup),
            set('terms.showTermsConditionsChat', showTermsConditionsChat),
            set('terms.tcChatVersion', tcChatVersion),
            set('terms.tcChatPdfLink', tcChatPdfLink)
          ]);

          if (passwordExpired) {
            const path = '/new-user-change-password';
            await call('auth.handler', { authSuccess, path });
          }
          else if ((showTermsConditions || showPrivacyAgreement) && !rmUserGroup) {
            const path = '/terms-conditions';
            await call('auth.dashboard2FARouting', { authSuccess, path });
          } else {
            set('ui.state.rsaPageName', path);

            let isVascoNTB;
            if (!vascoActivated && !webssoEnabled) {

              set('vascoauthentication.vascoModalType', VASCO_MODAL_TYPES.notActivated);
              [isVascoNTB] = await getValues(get('vascoauthentication.isNTB'));
              set('vascoauthentication.vascoVisible', true);
            }
            if (!isVascoNTB) {
              await call('auth.dashboard2FARouting', { authSuccess, path });
            }
          }
        } else {
          const path = '/admin';
          await call('auth.dashboard2FARouting', { authSuccess, path });
        }


        set('auth.loginBusy', false);
        set('auth.entitlementProcessed', true);
      }
    })
    .path('auth.login', {
      call: async ({ req }, { get, set, call }) => {
        set('auth.loginBusy', true);
        await set('app.user.cacheId', Date.now());
        await call('auth.resetInfoMessage');

        const { userId, password, type = "login" } = req.args[0];
        const ran_str = "random" + Math.round(Math.random() * 100);
        const [messages] = await getValues(get('i18n.messages'));

        const check_dot = userId.includes(".");
        if (check_dot) {
          await set('auth.invalidLogin', true);
          await set('auth.errorMsg', messages['app.auth.invalidLogin']);
          set('auth.loginBusy', false);
          return;
        }

        // const [
        // encryptionKeySuccess,
        // randomNum,
        // publicKey,
        // dummySesKey,
        // encryptionMSG,
        // ] = await getValues(get([
        //   `roster.ebanking.auth.pbOnlineEncryptionKey.${userId}.${type}.encryptionKeySuccess`,
        //   `roster.ebanking.auth.pbOnlineEncryptionKey.${userId}.${type}.randomNum`,
        //   `roster.ebanking.auth.pbOnlineEncryptionKey.${userId}.${type}.publicKey`,
        //   `roster.ebanking.auth.pbOnlineEncryptionKey.${userId}.${type}.dummySesKey`,
        //   `roster.ebanking.auth.pbOnlineEncryptionKey.${userId}.${type}.encryptionMSG`,
        //   ]));



        // const oEncryptionKeyObj = JSON.parse(
        //   await getValues(get(`roster.ebanking.auth.pbOnlineEncryptionJson.${userId}.${type}`))
        //   );

        const [oEncryptionKeyStr] = await getValues(get(`roster.ebanking.auth.pbOnlineEncryptionJson.${ran_str}.${userId}.${type}`));

        if (oEncryptionKeyStr && oEncryptionKeyStr.$type == "error") {
          await set('auth.invalidLogin', true);
          await set('auth.errorMsg', messages['app.login.unableToConnect']);
          set('auth.loginBusy', false);
          return;
        }
        const oEncryptionKeyObj = JSON.parse(oEncryptionKeyStr);
        const encryptionKeySuccess = oEncryptionKeyObj.encryptionKeySuccess;
        const randomNum = oEncryptionKeyObj.randomNum;
        const publicKey = oEncryptionKeyObj.publicKey;
        const dummySesKey = oEncryptionKeyObj.dummySesKey;
        const encryptionMSG = oEncryptionKeyObj.encryptionMSG;

        if (!encryptionKeySuccess || randomNum.$type == "error") {
          await set('auth.invalidLogin', true);
          const errorMessage = encryptionMSG.$type == "error" || encryptionMSG == '' ? 'Error in connection. Please reload.' : encryptionMSG;
          await set('auth.errorMsg', errorMessage);
          set('auth.loginBusy', false);
          return;
        }
        const encryptedPassword = '';
        // const [
        // sessionId,
        // authHeader,
        // authSuccess,
        // passwordExpired,
        // lastSession,
        // message,
        // ] = await getValues(get([
        //   `roster.ebanking.auth.login.${userId}.encrypted-${encryptedPassword}.dummySesKey-${dummySesKey}.sessionId`,
        //   `roster.ebanking.auth.login.${userId}.encrypted-${encryptedPassword}.dummySesKey-${dummySesKey}.authHeader`,
        //   `roster.ebanking.auth.login.${userId}.encrypted-${encryptedPassword}.dummySesKey-${dummySesKey}.authSuccess`,
        //   `roster.ebanking.auth.login.${userId}.encrypted-${encryptedPassword}.dummySesKey-${dummySesKey}.passwordExpired`,
        //   `roster.ebanking.auth.login.${userId}.encrypted-${encryptedPassword}.dummySesKey-${dummySesKey}.lastSession`,
        //   `roster.ebanking.auth.login.${userId}.encrypted-${encryptedPassword}.dummySesKey-${dummySesKey}.message`,
        //   ]));

        let agent = '';
        if (typeof navigator !== 'undefined' && navigator) {
          agent = navigator.userAgent;
        }
        const browserName = DetectBrowser(agent);
        const device = browserName != '' && browserName != null ? 'WEB_' + browserName.name + '_' + browserName.version : '';
        const device_info = device.replace(/\./g, '_');

        const oLoginResult = JSON.parse(
          await getValues(get(`roster.ebanking.auth.loginJson.${userId}.encrypted-${encryptedPassword}.dummySesKey-${dummySesKey}.app-${device_info}`))
        );

        const sessionId = oLoginResult.sessionId;
        const authHeader = oLoginResult.authHeader;
        const authSuccess = oLoginResult.authSuccess;
        const passwordExpired = oLoginResult.passwordExpired;
        const lastSession = oLoginResult.lastSession;
        const message = oLoginResult.message;
        console.log("authSuccess is:", authSuccess);

        if (authSuccess) {
          await set('auth.passwordExpired', passwordExpired);
        } else {
          set('auth.loginBusy', false);
          await set('auth.invalidLogin', true);
          await set('auth.errorMsg', message);
          return;
        }

        await Promise.all([
          set('auth.authHeader', authHeader),
          set('auth.passwordExpired', passwordExpired),
          set('auth.sessionId', sessionId),
          set('auth.userId', userId),
          set('auth.lastSession', lastSession),
        ]);



        const [_entitlementListData, _insightRead, _cache] = await getValues(get([

          `roster.data.getEntitlementList`,
          'roster.data.entitlement.insight.read',
          `roster.data.cache.${ran_str}`
        ]));
        const parsedEntitlementData = JSON.parse(_entitlementListData);
        const oEntitlementList = parsedEntitlementData;
        const entitlementModules = parsedEntitlementData && parsedEntitlementData.modules;
        const adminRead = oEntitlementList.marqueeadmin || false;
        oEntitlementList.insights = _insightRead;
        await set('auth.entitlement', oEntitlementList);

        const portfolioRead = oEntitlementList.dashboard || oEntitlementList.portfolio || false;
        const maturitiesRead = oEntitlementList.maturities || false;
        const insightsRead = oEntitlementList.insights || false;
        const reportsRead = oEntitlementList.reports || false;
        const notificationRead = oEntitlementList.notification || false;

        if (entitlementModules.includes(ENTITLEMENT.tradingModule)) {
          await set('auth.entitlements.trading', true);
          // Feature/EBANK-17839 create app without rendering
          // const [showTrade] = await getValues(get('app.config.trading.tradeComponentDisabled'));
          // if(!showTrade)
          //   await set('auth.entitlements.trading', true);
        }

        if (!adminRead && !portfolioRead && !maturitiesRead && !insightsRead && !reportsRead) {
          await set('auth.noEntitlement', true);
          set('auth.loginBusy', false);
          return;

        }


        let path = "";
        if (!adminRead) {
          const [_portfoliosTop, _portfolioLength, _insightsRoles] = await getValues(get([
            `roster.data.portfolios.top`,
            `roster.data.portfolios.length`,
            'roster.data.getInsightRoles',

          ]));
          await set('cioinsights.roles', _insightsRoles);
          // ALVIN: this is temporary fix, we need to make get currency work inside getValues
          // await call('auth.getUserInformation');
          // await set('auth.destinationCurrency', _currency);
          await set('app.user.portfolios.length', _portfolioLength);

          const topPortfolio = await JSON.parse(_portfoliosTop);
          const portfolioId = topPortfolio.id;
          const title = topPortfolio.title;
          const referenceCurrency = topPortfolio.referenceCurrency;
          const relId = topPortfolio.relId;
          const branchCode = topPortfolio.branchCode;
          // const [[portfolioId, title, referenceCurrency, relId, branchCode]] = await Promise.all([
          //   getValues(get([
          //     'roster.data.portfolios[0].id',
          //     'roster.data.portfolios[0].title',
          //     'roster.data.portfolios[0].referenceCurrency',
          //     'roster.data.portfolios[0].relId',
          //     'roster.data.portfolios[0].branchCode'
          //   ])),

          //   set('auth.authHeader', authHeader),
          //   set('auth.passwordExpired', passwordExpired),
          //   set('auth.sessionId', sessionId),
          //   set('auth.userId', userId),
          //   set('auth.lastSession', lastSession),
          // ]);
          if (portfolioId.$type == 'notFound') {
            await call('ui.history.replace', { pathname: '/noportfolios' });
            return;
          }
          // ;

          // const [
          //   portfolioRead,
          //   maturitiesRead,
          //   insightsRead,
          //   reportsRead,
          // ] = await getValues(get([
          //   'roster.data.entitlement.portfolio.read',
          //   'roster.data.entitlement.maturities.read',
          //   'roster.data.entitlement.insights.read',
          //   'roster.data.entitlement.reports.read',
          // ]));

          const portfolio = { id: portfolioId, title, referenceCurrency, relId, branchCode };
          path = (portfolioRead && '/portfolios') || (maturitiesRead && '/maturities') || (insightsRead && '/insights') || (reportsRead && '/reports');
          // const path = "/noportfolios";
          // await set('auth.authorised', authSuccess);
          await set('auth.authorised', true);
          await set('app.user.selectedPortfolioId', portfolioId);
          await set('app.user.selectedPortfolioData', portfolio);

          const [_discoveryHistoryList] = await getValues(get([
            'roster.data.discovery.history'
          ]));
          if (_discoveryHistoryList.$type != 'error' || _discoveryHistoryList.$type != 'atom') {
            await set('discovery.history', JSON.parse(_discoveryHistoryList));
          } else {
            await set('discovery.history', []);
          }

          await call('auth.getUserInformation');
          await set('rsa.rsaAuthorised', false);
          set('ui.state.portfolio.view.selectedId', 'chart');
          set('portfolio.portfolioBarDismissed', false);
          set('auth.loginBusy', false);
          if (notificationRead) {
            call('notifications.getUserNotifications');
          }
        } else {
          path = (adminRead && '/admin');
          await set('auth.authorised', true);
          // await call('auth.getUserInformation');
          await set('rsa.rsaAuthorised', false);
          set('auth.loginBusy', false);
        }

        if (passwordExpired) {
          const path = '/new-user-change-password';
          await call('auth.dashboard2FARouting', { authSuccess, path });
        } else {

          await call('auth.dashboard2FARouting', { authSuccess, path });
        }



      },
    })
    .path('auth.getUserInformation', {
      call: async ({ req }, { get, set }) => {

        const [
          newCurrency
        ] = await getValues(get([
          `roster.data.currencies.getCurrency`,
        ]));

        if (newCurrency) {
          await set('auth.destinationCurrency', newCurrency)
        }
      }
    })
    .path('auth.changePassword', {
      call: async ({ req }, { get, set, call }) => {
        set('auth.changePasswordBusy', true);
        await set('app.user.cacheId', Date.now());
        const { password, newPassword } = req.args[0];
        await call('auth.passwordChangeHandler', { password, newPassword });
      },
    })
    .path('auth.passwordChangeHandler', {
      call: async ({ req }, { get, set, call }) => {

        const {
          password,
          newPassword,
          type = "changePassword"
        } = req.args[0];

        const [userId] = await getValues(get(['auth.userId']));
        const [messages] = await getValues(get('i18n.messages'));

        const [
          encryptionKeySuccess,
          randomNum,
          publicKey,
          encryptionMSG,
        ] = await getValues(get([
          `roster.data.auth.pbOnlineChangePasswordEncryptionKey.${userId}.${type}.encryptionKeySuccess`,
          `roster.data.auth.pbOnlineChangePasswordEncryptionKey.${userId}.${type}.randomNum`,
          `roster.data.auth.pbOnlineChangePasswordEncryptionKey.${userId}.${type}.publicKey`,
          `roster.data.auth.pbOnlineChangePasswordEncryptionKey.${userId}.${type}.encryptionMSG`,
        ]));
        if (encryptionKeySuccess) {
          let encryptedPassword = '';
          const ribLogon = new RIBLogon();
          ribLogon.setKeyValue(publicKey);
          encryptedPassword = ribLogon.encyptPwdChange(password, newPassword, randomNum, messages);
          await set('auth.changePasswordErrorMessage', "");

          const oMessage = await getValues(get(`roster.data.auth.changePassword.encrypted-${encryptedPassword}.message`));
          const oChangePasswordError = oMessage != "";

          console.log("changePasswordSuccess:", oChangePasswordError);
          await set('auth.changePasswordError', oChangePasswordError);
          await set('auth.changePasswordErrorMessage', oMessage);
          set('auth.changePasswordBusy', false);

          if (!oChangePasswordError) {
            await call('ui.history.replace', { pathname: '/change-password-success' });
          }
        } else {
          set('auth.changePasswordBusy', false);
          await set('auth.changePasswordError', false);
          await set('auth.changePasswordErrorMessage', encryptionMSG);
        }
      },
    })
    .path('auth.globalAuthChangePassword', {
      call: async ({ req }, { get, set, call }) => {
        set('auth.changePasswordBusy', true);
        await set('app.user.cacheId', Date.now());
        const { password, newPassword, oldCryptoPassword, newCryptoPassword, token, randnr, pubkey, seskey } = req.args[0];
        await call('auth.globalAuthPasswordChangeHandler', { password, newPassword, oldCryptoPassword, newCryptoPassword, token, randnr, pubkey, seskey });
      },
    })
    .path('auth.globalAuthPasswordChangeHandler', {
      call: async ({ req }, { get, set, call }) => {

        const {
          password,
          newPassword,
          oldCryptoPassword,
          newCryptoPassword,
          token, randnr, pubkey, seskey,
          type = "changePassword"
        } = req.args[0];

        let [userId] = await getValues(get(['auth.userId']));
        const [regionCode] = await getValues(get(['config.regionCode']));
        const encryptedPassword = '';
        const oldEncryptedPassword = '';
        // let ribLogon = new RIBLogon();
        // ribLogon.setKeyValue(pubkey);
        // encryptedPassword = ribLogon.encyptPwdChange(password, newPassword, randnr);
        // oldEncryptedPassword = ribLogon.encyptPwd(password, randnr);
        let oMessage = "";
        if (envConfig.envConfig === EBANKINGWEBLUX) {
          userId = Base64.encode(userId);
          oMessage = await getValues(get(`roster.data.auth.glblAuthEBankchangePasswordForLux.${userId}.encryptedPassword-${encryptedPassword}.oldEncryptedPassword-${oldEncryptedPassword}.oldCryptoPassword-${oldCryptoPassword}.newCryptoPassword-${newCryptoPassword}.token-${token}.dummySesKey-${seskey}.${regionCode}`));
        } else {
          oMessage = await getValues(get(`roster.data.auth.glblAuthEBankchangePassword.${userId}.encryptedPassword-${encryptedPassword}.oldEncryptedPassword-${oldEncryptedPassword}.oldCryptoPassword-${oldCryptoPassword}.newCryptoPassword-${newCryptoPassword}.token-${token}.dummySesKey-${seskey}.${regionCode}`));
        }

        // const oChangePasswordError = oMessage != "" ? true : false;
        const parsOMessage = JSON.parse(oMessage);
        let oChangePasswordError = parsOMessage.message != "";
        const [messages] = await getValues(get('i18n.messages'));
        await set('auth.passwordUsedError', false);
        if (parsOMessage.returnCode === ERGON_API_ERROR_CODES.passwordExpired) {
          oChangePasswordError = true;
          await set('auth.changePasswordError', oChangePasswordError);
          await set('auth.changePasswordErrorMessage', messages['app.forgotPassword.tempPasswordExpiry']);
          await set('auth.changePasswordBusy', false);
          await set('auth.passwordExpired', true);
          return;
        }
        if (parsOMessage.returnCode === ERGON_API_ERROR_CODES.wrongExistingPassword) {
          oChangePasswordError = true;
          await set('auth.changePasswordError', oChangePasswordError);
          await set('auth.changePasswordErrorMessage', messages['app.changepassword.errormsg.wrongExistingPassword']);
          await set('auth.changePasswordBusy', false);
          return;
        } else if (parsOMessage.returnCode === ERGON_API_ERROR_CODES.passwordAlreadyUsed) {
          oChangePasswordError = true;
          await set('auth.passwordUsedError', true);
          await set('auth.changePasswordError', oChangePasswordError);
          await set('auth.changePasswordErrorMessage', messages['app.changepassword.errormsg.passwordAlreadyUsed']);
          await set('auth.changePasswordBusy', false);
          return;
        }

        if (parsOMessage.returnCode === AUTHORIZATION_ERROR_CODES.invalidPassword) {
          oChangePasswordError = true;
          await set('auth.changePasswordError', oChangePasswordError);
          await set('auth.changePasswordErrorMessage', messages['app.changepassword.errormsg.passwordAlreadyUsed']);
          await set('auth.changePasswordBusy', false);
          return;
        }
        const errorMsg = (parsOMessage.returnCode && messages['app.error.errorCode.' + parsOMessage.returnCode]) ? messages['app.error.errorCode.' + parsOMessage.returnCode] : parsOMessage.message;
        await set('auth.changePasswordError', oChangePasswordError);
        await set('auth.changePasswordErrorMessage', errorMsg);
        set('auth.changePasswordBusy', false);

        const [isTempPwdGenerated] = await getValues(get('forgotPassword.generateTempPwdResultValid'));

        if (!oChangePasswordError) {
          // await call('ui.history.replace', { pathname: '/change-password-success' });
          const [eCredPwd] = await getValues(get('auth.eCredPwd'));

          if ((eCredPwd && eCredPwd.status) || isTempPwdGenerated) {
            await call('forgotPassword.updateECredStatus', ECREDENTIALS.EPWD_RESET_COMPLETED);
            await set('auth.changePasswordForECred', ECREDENTIALS.EPWD_RESET_COMPLETED);
          }
          isTempPwdGenerated ? await set('forgotPassword.showCurrentStep', FORGOT_PASSWORD_FLOW_STEPS[3]) : await call('ui.history.replace', { pathname: '/change-password-success' });
        }
      },
    })
    .path('auth.handler', {
      call: async ({ req }, { set, call }) => {
        const {
          authSuccess,
          path,
        } = req.args[0];

        if (!authSuccess) {
          await set('auth.invalidLogin', true);
          return;
        }
        await set('auth.dashboardAuthorised', true);
        await call('ui.history.replace', { pathname: path });
      },
    })
    .path('auth.logout', {
      call: async ({ req }, { get, set, call }) => {
        const ran_str = Guid();
        // const pathValue = req.args[0] ? req.args[0] : '/logout'

        // const pathValue = config.webfolder == '' ? '/logout' : config.webfolder + '/logout'
        const webfolder = Settings.webfolder;
        const pathValue = webfolder != "" ? "/" + webfolder + '/logout' : "/logout";


        set('auth.authHeaderValue', false);
        const logoutDsc = req.args.length > 0 ? Base64.encode(JSON.stringify(req.args[0])) : " ";
        let agent = '';
        if (typeof navigator !== 'undefined' && navigator) {
          agent = navigator.userAgent;
        }
        const browserName = DetectBrowser(agent);
        const device = browserName != '' && browserName != null ? 'WEB_' + browserName.name + '_' + browserName.version : '';
        const channelInfo = device.replace(/\./g, '_');
        const [logoutSuccess, dataCacheBust] = await getValues(get([
          `roster.data.auth.logout.["${channelInfo}"]["${logoutDsc}"]`,
          `roster.data.cache.p${ran_str}`
        ]));

        // hard redirect to do logout.. commented clearing of the path so there will be no property refresh on top of the cycle.
        window.location.href = pathValue;

        if (!logoutSuccess) {
          await set('auth.logoutSuccess', false);
          // return;
        }


        // set('auth.authHeader', " ");
        // set('auth.sessionId', "");
        // set('auth.userId', "");
        // set('auth.destinationCurrency', "");
        // set('app user.selectedPortfolioData', "");
        // set('app user.cacheId', "");
        // set('portfolio.assetClassName', "");
        // set('auth.langCode', "");
        // await set('vascoauthentication.vascoVisible', false);



        // const [logoutSuccess] = await getValues(get([`roster.data.auth.logout`]));
        // await set('app.user.cacheId', Date.now());

        // set('auth.sessionExpired', false);
        // set('auth.authorised', false);
        // set('auth.passwordExpired', "");
        // set('auth.changePasswordBusy', false);
        // set('auth.logoutSuccess', true);
        // set('auth.errorMsg', "");
        // set('auth.invalidLogin', "");
        // set('auth.userGroup', "");
        // set('auth.noRmAccess', "");
        // set('rsa.rsaVisible', false);



        // set('cioinsights.busy', false);
        // set('cioinsights.fileReady', false);
        // set('cioinsights.attachmentFile', "");
        // set('cioinsights.offSet', 0);
        // set('cioinsights.endOfRecords', false);
        // set('cioinsights.articleContent', "");
        // set('cioinsights.articleID', "");
        // set('cioinsights.roles', "");
        // set('cioinsights.articleList', "");
        // set('vascoauthentication.vascoModalType', null);
        // set('vascoauthentication.statusCode', null);

        // call('inactive.stopTimer');



        // await call('ui.history.push', { pathname: pathValue }, true);
      },
    })
    .path('auth.logoutNoRedirection', {
      call: async ({ req }, { get, set, call }) => {
        const ran_str = Guid();
        const [logoutSuccess, dataCacheBust] = await getValues(get([
          'roster.data.auth.logout',
          `roster.data.cache.p${ran_str}`
        ]));
      },
    })
    .path('auth.stateProviderReady', variable(false))
    .path('auth.authenticationJson', variable(""))
    .path('webssoauthentication.webssoEnabled', variable(false))
    .path('webssoauthentication.isSynced', variable(false))
    .path('auth.loginBusy', variable(false))
    .path('auth.changePasswordBusy', variable(false))
    .path('auth.changePasswordErrorMessage', variable(""))
    .path('auth.authorised', variable())
    .path('auth.sessionId', variable())
    .path('auth.lastSession', variable())
    .path('auth.lastSessionTZ', variable())
    .path('auth.authHeader', variable())
    .path('auth.userId', variable(''))
    .path('auth.userGroup', variable())
    .path('auth.errorMsg', variable(""))
    .path('discovery.history', variable())
    .path('auth.entitlement', variable(""))
    .path('auth.isAdminUser', variable(false))
    .path('auth.isPaymentCheck', variable(false))
    .path('auth.isVisitedLinkActive', variable({}))

    .path('auth.resetInfoMessage', {
      call: async ({ req }, { set }) => {
        set('auth.invalidLogin', null);
        set('auth.invalidCredentials', false);
        set('auth.errorMsg', null);
        set('auth.isLocked', null);
        set('auth.noEntitlement', false);
        set('auth.passwordExpired', null);
        set('auth.changePasswordError', null);
        set('auth.passwordUsedError', null);
        set('auth.unplannedDowntime', null);
        set('auth.plannedDowntime', null);
        set('auth.logoutSuccess', null);
        set('auth.sessionExpired', null);
        set('auth.noRmAccess', null);
        set('auth.noEntitlementUserPf', false)
        set('auth.logoutExpireSuccess', false)
        set('auth.unAuthorisedUser', null);
        set('rsa.rsaAuthorised', false);
      },
    })
    .path('webssoauthentication.dwoEntitlementFlag', variable(false))
    .path('webssoauthentication.errorMessage', variable(""))
    .path('userprofile.userDetails', variable(null))
    .path('auth.portfolioLoaded', variable(false))
    .path('auth.plannedServerDowntimeCheck', {
      call: async ({ req }, { set }) => {

        set('auth.plannedDowntime', false);

      },
    })

    .path('terms.saveTermsPrivacy', {
      call: async ({ req }, { set, get, call }) => {
        let { seenTerms, seenPrivacy, termsUrl, privacyUrl, tcVersion, paVersion, termsChatUrl, seenChatTerms, tcChatVersion, seenSummary } = req.args[0];
        const channel = 'web';
        if (termsUrl) termsUrl = termsUrl.replace('.', '<dot>');
        if (privacyUrl) privacyUrl = privacyUrl.replace('.', '<dot>');
        if (termsChatUrl) termsChatUrl = termsChatUrl.replace('.', '<dot>');
        const [oResult] = await getValues(get(`roster.data.terms.saveTermsConditions.encrypted-${seenTerms}.encrypted-${seenPrivacy}.encrypted-${channel}.encrypted-${termsUrl}.encrypted-${privacyUrl}.encrypted-${tcVersion}.encrypted-${paVersion}.encrypted-${termsChatUrl}.encrypted-${seenChatTerms}.encrypted-${tcChatVersion === null ? '' : tcChatVersion}.encrypted-${seenSummary}`));
        const [checkPasswordExpire, authSuccess] = await getValues(get(['auth.passwordExpired', 'auth.authSuccess']));
        const [vascoActivated, regionCode] = await getValues(get(['auth.vascoActivated', 'config.regionCode']));
        const [webssoEnabled] = await getValues(get('webssoauthentication.webssoEnabled'));
        if (checkPasswordExpire) {
          const path = '/new-user-change-password';
          await call('auth.dashboard2FARouting', { authSuccess, path });
        } else {
          let path = '';
          if (regionCode === 'CH') /* WMCE-4427 Path changed to new dashboard summary screen */
            path = '/dashboard';
          else
            path = '/portfolios';
          if (!vascoActivated && !webssoEnabled) {
            // EBANK-19678 : ETB RSA browser login issue after Terms-Condition Accept
            set('vascoauthentication.vascoVisible', false);
            set('vascoauthentication.vascoModalType', VASCO_MODAL_TYPES.noVasco);
          }
          await call('auth.dashboard2FARouting', { authSuccess, path });
        }
      },
    })

    .path('loginTerms.getPdfLink', {
      call: async ({ req }, { set, get, call }) => {
        const branchCode = await getValues(get('app.config.branchCode'));

        const selLanguage = await AsyncStorage.getItem('SelectedLanguageCode');

        function get_language(selLanguage) {
          const dash_index = selLanguage.indexOf('-')
          if (dash_index >= 0) {
            if (selLanguage.startsWith('zh')) {
              return (selLanguage.substring(dash_index + 1, selLanguage.length)).toLowerCase()
            }

            return selLanguage.substring(0, dash_index)
          }
          return selLanguage
        }

        const selLangCode = selLanguage != null ? get_language(selLanguage) : null;
        const langCode = isEmpty(selLangCode) ? 'en' : selLangCode;

        await set('auth.langCode', langCode);
        const [oResult] = await getValues(get(`roster.data.loginTerms.getPdfLink.dummyBrch-${branchCode}`));
        const [messages] = await getValues(get('i18n.messages'));   // WMCE-33534 - Error message when wso2 is down
        if (oResult && oResult.$type == "error") {
          if (oResult.value.message.includes(ERROR_CODE_WSO2) || oResult.value.message.includes('connect')) {
            await set('auth.invalidLogin', true);
            await set('auth.errorMsg', messages['app.login.errorMessage.WSO2IsDown']);
            await set('auth.isWso2Down', true);
            await set('banner.isDowntime', true);
          }
        }

        isValidJsonString(oResult).then(async (data) => {
          await Promise.all(set('loginTerms.pdfLinkData', JSON.parse(oResult)));
        }).catch(() => {
          console.log("loginTerms.pdfLinkData Error");
        });
      }
    })
    .path('auth.dashboard2FARouting', {
      call: async ({ req }, { get, set, call }) => {
        const {
          authSuccess,
          path,
        } = req.args[0];
        const [regionCode] = await getValues(get(['config.regionCode']));

        if (DASHBOARD_2FA_REGIONS.includes(regionCode)) {
          await set('auth.dashboard2FACheck', true);
          await call('rsa.changePage', path);
          set('auth.loginBusy', false);

        } else {
          await call('auth.getDashboardContent');

          await set('auth.dashboard2FACheck', false);
          await set('auth.dashboardAuthorised', true);
          await call('auth.handler', { authSuccess, path });
        }
      },
    })
    .path('auth.setLogoutConfirmVisible', {
      call: async ({ req }, { set, get }) => {

        const [regionCode] = await getValues(get(['config.regionCode']));
        if (DASHBOARD_2FA_REGIONS.includes(regionCode)) {
          set('auth.logoutConfirmVisible', req.args[0]);
        }
      },
    })
    .path('auth.setAuthorised', {
      call: async ({ req }, { set }) => {
        set('auth.authorised', req.args[0]);
      },
    })
    .path('payments.disableTabs', variable(false))
    .path('payments.enablePopUpTab',variable(null))
    .path('auth.invalidLogin', variable())
    .path('auth.noEntitlement', variable(false))
    .path('auth.passwordExpired', variable())
    .path('auth.authSuccess', variable())
    .path('auth.changePasswordError', variable())
    .path('auth.passwordUsedError', variable())
    .path('auth.unplannedDowntime', variable())
    .path('auth.plannedDowntime', variable())
    .path('auth.logoutSuccess', variable())
    .path('auth.assetTabSelectedIndex', variable(0))
    .path('auth.destinationCurrency', variable())
    .path('auth.sessionExpired', variable())
    .path('auth.isLocked', variable())
    .path('auth.invalidCredentials', variable(false))
    .path('terms.showTermsConditions', variable(""))
    .path('terms.showPrivacyAgreement', variable(""))
    .path('terms.tcPdfLink', variable(""))
    .path('terms.language', variable(""))
    .path('terms.paPdfLink', variable(""))
    .path('terms.tcVersion', variable(""))
    .path('terms.paVersion', variable(""))
    .path('terms.rmUserGroup', variable(""))
    .path('terms.newUserTc', variable(""))
    .path('terms.newUserPa', variable(""))
    .path('terms.termsChatUrl', variable(""))
    .path('terms.seenChatTerms', variable(false))
    .path('loginTerms.pdfLinkData', variable(""))
    .path('auth.cryptoEncryptedObj', variable())
    .path('auth.vascoActivated', variable(false))
    .path('auth.vascoFlow', variable())
    .path('auth.path', variable())
    .path('auth.entitlementProcessed', variable(false))
    .path('auth.jwt', variable(""))
    .path('auth.cryptoEncryptedObjSuccess', variable(false))
    .path('auth.authHeaderValue', variable(true))
    .path('auth.channel', variable(''))
    .path('auth.deviceCode', variable(''))
    .path('auth.dashboard2FACheck', variable(''))
    .path('auth.dashboardAuthorised', variable())
    .path('auth.entitlementPath', variable())
    .path('auth.logoutConfirmVisible', variable(false))
    .path('auth.noEntitlementUserPf', variable(false))
    .path('auth.paymentAvailableList', variable(""))
    .path('auth.isNonActivePortfolio', variable(false))
    .path('auth.noRmAccess', variable())
    .path('auth.entitlements.trading', variable(false))
    .path('auth.clientAdminAccess', variable(false))
    .path('auth.topPortfolio', variable(null))
    .path('auth.portfolioLength', variable(null))
    .path('auth.insightsRoles', variable(null))
    .path('auth.vascoServerTime', variable(null))
    .path('auth._discoveryHistoryList', variable(null))
    .path('auth.rmiaDetails', variable(null))
    .path('auth.notificationData', variable(null))
    .path('auth.docsignData', variable(null))
    .path('auth.deviceInfo', variable(null))
    .path('portfolios.blank', variable(null))
    .path('userprofile.prefLanguage', variable(null))
    .path('userprofile.prefLanguageSaved', variable(false))
    .path('auth.logoutExpireSuccess', variable())
    .path('vascoauthentication.showSpinner', variable(false))
    .path('vascoauthentication.userDeviceDetails', variable([]))
    .path('auth.loadportfoliosrc', variable(false))
    /* Show Summary of T&C WMCE-22628 */
    .path('terms.showSummaryOfServices', variable(false))
    .path('terms.ssPdfLink', variable(""))
    .path('terms.ssVersion', variable(""))
    .path('terms.isModalOpen',variable(false))  /*WMCE-50645 if T&C modal is there than set it as true */

    /* RM Access Entitlement flags added */
    .path('auth.isRMUserGroup', variable(false))
    .path('auth.addBeneficiaryDisabled', variable(false))
    .path('auth.settingsDisabled', variable(false))
    .path('auth.documentDownloadDisabled', variable(false))
    .path('auth.documentPreviewDisabled', variable(false))
    .path('auth.documentReadDisabled', variable(false))
    .path('auth.paymentSubmitDisabled', variable(false))
    .path('auth.isNotificationDisabledForRM', variable(false))

    /* Data Extracts */
    .path('auth.entitlements.dataExtracts', variable(false))
    .path('auth.entitlements.transactions', variable(false))

    /* Dashboard variables */
    .path('userprofile.prefCurrency', variable(null))
    .path('userprofile.baseCurrency', variable(null))
    .path('userprofile.prevPrefCurrency', variable(null))

    /** FAQ list */
    .path('faq.consolidatedList', variable([]))
    .path('securityTips.consolidatedList', variable([]))
    .path('auth.e2eCryptoObj', variable(null))
    .path('auth.isWso2Down', variable(false))

    /* EBANK-9918 : Multlilanguage: Language setting Change for CH
    // function to get user preferred language in userprofile
    */
    .path('auth.setUserPrefLanguage', {
      call: async ({ req }, { get, set }) => {
        const [languageObj] = await getValues(get('userprofile.prefLanguage'));
        if (languageObj) {
          let langObjs = [];
          // access language-list.json for setting SelectedLanguage & SelectedLanguageCode
          const regionLangList = languageData.languageList;
          regionLangList.map(element => {
            if (element.language.includes(languageObj)) {
              langObjs = element;
              return langObjs;
            }
            return langObjs
          });
          if (langObjs) {
            await AsyncStorage.setItem(LANGUAGE_KEY.SELECTED_LANGUAGE, langObjs.language);
            await AsyncStorage.setItem(LANGUAGE_KEY.SELECTED_LANG_CODE, langObjs.langCode);
            await set('languages.destLanguage', langObjs.language);
            await set('languages.destLanguageCode', langObjs.langCode);
          }
        }
      }
    })
    /* EBANK-9918 : Multlilanguage: Language setting Change for CH
     // function to save user preferred language in userprofile
    */
    .path('userprofile.saveUserPrefLanguage', {
      call: async ({ req }, { get, set, call }) => {
        const preferredLang = req.args[0].prefLanguage;
        const inputParam = preferredLang.language;
        const guidStr = Guid();
        const [result] = await getValues(get(`roster.data.saveUserPrefLanguage["${inputParam}"]["${guidStr}"]`));
        isValidJsonString(result).then(async (data) => {
          if (data.returnCode === 'SUCCESS') {
            await AsyncStorage.setItem(LANGUAGE_KEY.SELECTED_LANG_CODE, preferredLang.langCode);
            await AsyncStorage.setItem(LANGUAGE_KEY.SELECTED_LANGUAGE, preferredLang.language);
            const langCode = getLanguage(preferredLang.langCode);
            await set('auth.langCode', langCode);
            await set('languages.destLanguage', preferredLang.language);
            await set('languages.destLanguageCode', preferredLang.langCode);
            // await call('ui.history.push', { pathname: '/loadingview' }, true);
            await set('userprofile.prefLanguageSaved', true);

            await set('languages.loadingLanguage', false);

            const [currentPath] = await getValues(get('ui.history.currentLocation.pathname'));
            if (currentPath.includes("/profile/language-options")) {
              await call('ui.history.push', { pathname: '/profile' }, true);
              setTimeout(async () => {
                const [messages] = await getValues(get('i18n.messages'));
                alert(messages['app.profile.language.changeLanguageMsg']);
              }, 0);
            }
          }
          if (data.error) {
            await set('userprofile.prefLanguageSaved', false);
          }
        }).catch(async () => {
          await set('userprofile.prefLanguageSaved', false);
        });

        function getLanguage(langCode) {
          const dashIndex = langCode.indexOf('-')
          if (dashIndex >= 0) {
            return langCode.substring(0, dashIndex)
          }
          return langCode
        }
      }
    })

  return routeConfig;
};
